/**
 * Phone number validation utilities
 */

/**
 * Parses a phone number by removing formatting characters and normalizing the format
 * @param phoneNumber - The phone number to parse
 * @returns The parsed phone number with formatting removed
 */
export function parsePhoneNumber(phoneNumber: string): string {
  return phoneNumber.replace(/^\+/, '00').replace(/[\s\-\.+\(\)]/g, '');
}

/**
 * Validates if a parsed phone number is valid
 * @param parsedPhoneNumber - The parsed phone number to validate
 * @returns True if the phone number is valid, false otherwise
 */
export function isValidPhoneNumber(parsedPhoneNumber: string): boolean {
  return parsedPhoneNumber.length > 2 &&
         parsedPhoneNumber.length <= 20 &&
         parsedPhoneNumber.match(/^(00)?\d+$/) !== null;
}
